import { alpha } from '@mui/material';
import { clamp } from '@ui/style/clamp-calculator';
import { between } from '@ui/style/style';
import { useResponsive } from '@ui/style/useResponsive';
import { bottomNavigation, headerHeight, spaceAboveHeader } from '@ui/style/variables';
const useTasksStyles = () => {
    const { isMobileIpadNavigation } = useResponsive();
    const headingHeight = 64;
    const statusHeight = 56.8;
    const mobileTaskTabView = 45.18;
    const cardContainerHeightDesktop = `${spaceAboveHeader + headerHeight + headingHeight + statusHeight - 5}px`;
    const cardContainerHeightMobile = `${headerHeight + mobileTaskTabView + bottomNavigation}px`;
    return {
        main: {
            display: 'flex',
            flexDirection: 'column',
            gap: isMobileIpadNavigation ? 1 : 4.25,
            px: isMobileIpadNavigation ? 0 : clamp.calculate(8, 32),
            overflow: 'hidden',
            height: '100%'
        },
        mobileScreenHeader: {
            between,
            flexDirection: 'row',
            background: (theme) => theme.palette.common.white,
            mx: (theme) => theme.spacing(2),
            height: '100%'
        },
        mobileScreenHeadingButton: {
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            alignItems: 'center'
        },
        tasksContainer: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            mt: 1,
            maxHeight: { xs: 'calc(100dvh - 129px)', lg: 'calc(100dvh - 195px)' },
            gap: (theme) => theme.spacing(2),
            paddingBottom: 1
        },
        addNewTaskHeading: {
            color: (theme) => theme.palette.text.primary,
            whiteSpace: 'nowrap',
            bgcolor: (theme) => alpha(theme.palette.background.paper, 0.92),
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            borderRadius: (theme) => theme.spacing(1.5),
            px: (theme) => theme.spacing(2),
            py: (theme) => theme.spacing(1.5)
        },
        bottomNewTaskDrawer: {
            background: (theme) => theme.palette.common.white92,
            p: isMobileIpadNavigation ? 0 : 2,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16
        }
    };
};
export default useTasksStyles;
